export default "__VITE_ASSET__BhFi$hyN__"